import React from "react";

import { IAddButton } from "./interface";
import { Container, PlusIcon } from "./styles";
import BluePlus from "../../assets/procedure/blue_plus.svg";
import Plus from "../../assets/procedure/plus.svg";
import { useReadOnly } from "../../contexts/ReadOnlyContext";

export const AddButton: React.FC<IAddButton> = ({
  onClick,
  id,
  style,
  icon,
  widthHeight,
  disabled,
}) => {
  const ro = useReadOnly();
  const isDisabled = ro || disabled;

  const handleClick = () => {
    if (!isDisabled && onClick) {
      onClick();
    }
  };

  return (
    <Container
      data-cy="add-button"
      id={id}
      type="button"
      onClick={handleClick}
      style={style}
      widthHeight={widthHeight}
      disabled={isDisabled}
    >
      <PlusIcon id="add_button">
        {icon ? <img src={BluePlus} alt="" /> : <img src={Plus} alt="" />}
      </PlusIcon>
    </Container>
  );
};
